import React, { useState, useEffect, useContext } from 'react';
import conf from '../../conf/ajax';
import { Link } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { UserContext } from '../../store/user_context';

function MenuItem({ url, label, current, aliases, icon })
{
    let classes = (current.split('?')[0] === url.split('?')[0]) ? 'active' : '';
    if(classes === '' && aliases.length > 0)
    {
        classes = (aliases.indexOf(current.split('?')[0]) > -1) ? 'active' : '';
    }
    return (
        <li className={classes}>
            <Link to={url}><i className={icon}></i> <span>{label}</span></Link>
        </li>
    );
}

export default function MyQaActivity()
{
    // reading user data
    const user_data = useContext(UserContext);
    const [username, setUsername] = useState(false);
    const location = useLocation();

    useEffect(() =>
    {
        if(user_data && user_data.userid) setUsername(user_data.userid);
    }, [user_data]);

    const locations =
    [
        {
            id: 'main',
            url: `${conf.route.answer}`,
            label: 'Recently asked questions',
            aliases: [`${conf.route.main}`],
            icon: 'fa-solid fa-person-circle-question'
        },
        {
            id: 'tags',
            url: conf.route.tags,
            label: 'Browse by tag',
            aliases: [],
            icon: 'fa-solid fa-tags'
        },
        {
            id: 'ask',
            url: conf.route.ask,
            label: 'Ask question',
            aliases: [],
            icon: 'ui-icon-help'
        },
        {
            id: 'myqaa',
            url: `${conf.route.user}`.replace(':id', username),
            label: 'Your Q&A activity',
            aliases: [],
            icon: 'icon-user'
        },
        {
            id: 'notification',
            url: conf.route.notification,
            label: 'Notifications settings',
            aliases: [],
            icon: 'ui-icon-notifications-bell'
        },
        {
            id: 'rules',
            url: conf.route.rules,
            label: 'Q&A basic rules',
            aliases: [],
            icon: 'fa-solid fa-file-signature'
        },
    ];

    return (
        <>
        <ul className="vertical-nav">
                {locations.map(item => (
                    <MenuItem key={item.id}
                        url={item.url}
                        label={item.label}
                        current={location.pathname}
                        aliases={item.aliases}
                        icon={item.icon}
                    />
                ))}
        </ul>

        </>
    );
};